import { Converter, Unit } from "src/api/sure-api/ssq/useGetOneSsqVersion";
import { canonicalFromSi } from "./unitConversion";

export type UnitConverterOption = {
    id: string;
    kind: "recipe" | "unit";
    label: string;
    code: string;
    abbreviation: string;
    recipeId: number | null;
    factor: number;
    source?: string | null;
};

export type UnitConverterContext = {
    converter?: Converter | null;
    unit?: Pick<Unit, "id" | "factorToBase"> | null;
};

export function buildUnitConverterOptions(context: UnitConverterContext): UnitConverterOption[] {
    const { converter, unit: targetUnit } = context;
    if (!converter || !targetUnit) {
        return [];
    }

    const options: UnitConverterOption[] = converter.recipes.map((recipe) => ({
        id: `recipe-${recipe.id}`,
        kind: "recipe",
        label: recipe.label ?? recipe.title,
        code: recipe.fromUnit.code,
        abbreviation: recipe.fromUnit.abbreviation,
        recipeId: recipe.id,
        factor: recipe.factor,
        source: recipe.source,
    }));

    const targetFactor = targetUnit.factorToBase;
    if (targetFactor == null) {
        return options;
    }

    for (const siUnit of converter.siUnits) {
        const factor = canonicalFromSi(1, siUnit.factorToBase, targetFactor);
        if (siUnit.id === targetUnit.id || factor === null) {
            continue;
        }

        options.push({
            id: `si-${siUnit.id}`,
            kind: "unit",
            label: siUnit.abbreviation,
            code: siUnit.code,
            abbreviation: siUnit.abbreviation,
            recipeId: null,
            factor,
        });
    }

    return options;
}
